var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModalSlot",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.getTitle,
        width: _vm.getModalSize,
        "custom-class": "verify-account__action-required",
        theme: "light",
        "z-index": "999999",
        "hide-confirm-button": "",
        "hide-cancel-button": "",
        "close-icon": "",
      },
      on: { close: _vm.onClose, clickOutside: _vm.onClose },
    },
    [
      _c(
        "div",
        { staticClass: "verify-account__container" },
        [
          _c("p", [
            _vm._v(
              "Identificamos uma inconsistência na verificação de sua conta. Por motivos de segurança sua conta foi bloqueada, entre em contato com nosso suporte para regularizar sua situação."
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "error",
              attrs: { block: "" },
              on: { click: _vm.openSupport },
            },
            [_vm._v("\n      Falar com suporte\n    ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }